export default {
  props: {
    // 筛选列表
    filterList: {
      default: () => [],
      type: Array,
    },
    // 是否展示名称分割线
    showSplit: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    changeFilter(item, index, filterType) {
      this.$emit('changeFilter', { item, index, filterType })
    },
    changeColor(item, index, filterType, isHover = false) {
      this.$emit('changeColor', {
        item,
        index,
        filterType,
        isHover,
      })
    },
  },
}
